import { AppRouteProps } from "@bsm/component";
import { BankDetailsContainer } from "./container/BankDetailsContainer";
import { BankCreateContainer } from "../create/container/BankCreateContainer";


export const BankDetailsRoute = [
    {
        path: ":bankId",
        element: <BankDetailsContainer />
    },
    {
        path: ":bankId/edit",
        element: <BankCreateContainer />
    },
] as Array<AppRouteProps>